import { useFormContext } from "react-hook-form"
import getOwnMessage from "./getOwnMessage"
import { FieldError } from "@/ui/components/ui/field"

type Props = {
  path?: string
  className?: string
}

export default function FormError({
  path = "root.formError",
  className = "mb-4",
}: Props) {
  const {
    formState: { errors },
  } = useFormContext()

  // Read both unconditionally. Routing through a ternary seems to break
  // RHF's formState proxy tracking (empirically: conditional access fails
  // to establish/retain the subscription that triggers re-render).
  const rootMessage = errors.root?.formError?.message
  const pathMessage = getOwnMessage(errors, path)
  const message = pathMessage ?? rootMessage

  return !message ? null : (
    <FieldError className={className}>{message}</FieldError>
  )
}
